export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setProviders(state, providers) {
    state.providers = providers;
  },
  setEvents(state, events) {
    state.events = events;
  },
  setTypeEvents(state, typeEvents) {
    state.typeEvents = typeEvents;
  },
  setTypeCommands(state, typeCommands) {
    state.typeCommands = typeCommands;
  },
  setIntegration(state, integration) {
    state.integration = integration;
  },
  setIntegrationList(state, integrationList) {
    state.integrationList = integrationList;
  },
  setKajabiList(state, kajabiList) {
    state.kajabiList = kajabiList;
  },
  setKajabiIntegration(state, kajabiIntegration) {
    state.kajabiIntegration = kajabiIntegration;
  },
  setTags(state, tags) {
    state.tags = tags;
  },
  setCoproducerProducts(state, products) {
    state.coproducerProducts = products;
  },
  setAllZoomIntegrations(state, all_zoom_integrations) {
    state.all_zoom_integrations = all_zoom_integrations;
  }
};
